import {Command} from "./Command";
import {LooseGamePlay} from "../model/game-play";
import {ODK} from "../model/odk";
import {PlayType} from "../model/playType";

export class SetKickerCommand implements Command {
  constructor(
    private gamePlay: LooseGamePlay,
    private kicker: number
  ) { }

  execute() {
    const playTypeOffensif = [
      PlayType.KO,
      PlayType.OnsideKick,
      PlayType.Punt,
      PlayType.ExtraPt,
      PlayType.FG,
    ];
    const playTypeDeffensif = [
      PlayType.KOREC,
      PlayType.OnsideKickRec,
      PlayType.PuntRec,
      PlayType.ExtraPtBlock,
      PlayType.FGBlock,
    ];

    console.log('COMMAND SetKickerCommand', this.kicker)
    if (this.gamePlay.odk !== ODK.Kick) {
      throw new Error(`ODK (${this.gamePlay.odk}) doit être à Kick pour la commande SetKickerCommand`)
    }

    // FIXME Sébas pourrait aussi être Onside Kick, Onside Kick rec, et quoi d'autre
    if (playTypeOffensif.includes(this.gamePlay.playType!)) {
      this.gamePlay.kicker = this.kicker
      return
    }

    if (playTypeDeffensif.includes(this.gamePlay.playType!))  {
      this.gamePlay.oppKicker = this.kicker
      return;
    }

    throw new Error('playType non valide pour la commande SetKickerCommand')
  }
}
